import React, { useContext, useState } from 'react';
import { useCartAdd } from 'src/hooks/useCartAdd';
import { useModal } from 'src/hooks/useModal';
import { I18nContext } from 'src/stores/I18n';
import { Presenter } from './Presenter';

export const AlcoholAgeVerificationModal: React.FC = () => {
  const { isVisible, setIsVisible, modalParams, setModalParams } = useModal('alcoholAgeVerificationModal');
  const [isCheck, setIsCheck] = useState(false);
  const localeResources = useContext(I18nContext);
  const { onAddToCart } = useCartAdd({ targetAttributionToken: modalParams.extraData?.targetAttributionToken });

  if (!isVisible) return null;

  const handleCheckboxChange = () => {
    setIsCheck(!isCheck);
  };

  const handleAddToCart = () => {
    if (modalParams.product && modalParams.quantity) {
      setIsCheck(false);
      onAddToCart(modalParams.product, modalParams.quantity, 'alcohol_age_verification_modal');
      setIsVisible(false);
    }
  };

  const handleCloseModal = () => {
    setModalParams({
      type: 'info'
    });
    setIsVisible(false);
  };

  return (
    <Presenter
      title={localeResources.products.chemicals.confirm}
      japaneseLowDesc={localeResources.products.alcohol.japaneseLowDesc}
      ageVerification={localeResources.products.alcohol.ageVerification}
      passportAgeVerification={localeResources.products.alcohol.passportAgeVerification}
      reminderForAlcoholImportTaxExemptionLimit={
        localeResources.products.alcohol.reminderForAlcoholImportTaxExemptionLimit
      }
      sakeNotice={localeResources.sakeNotice.text1}
      yesAge20={localeResources.products.alcohol.yesAge20}
      addToCartText={localeResources.cart.addToCart}
      isCheck={isCheck}
      onCheckboxChange={handleCheckboxChange}
      onAddToCart={handleAddToCart}
      closeModal={handleCloseModal}
    />
  );
};
